(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairLettersController', PhysicalFairLettersController);
    PhysicalFairLettersController.$inject = ['$uibModal', 'ExpoService', 'CitiesByExpoService', 'PhysicalFairService','$timeout'];
    function PhysicalFairLettersController($uibModal, ExpoService, CitiesByExpoService, PhysicalFairService,$timeout) {
        var vm = this;

        vm.flag                  = false;
        vm.commentsResult        = [];
        vm.expoSelected          = [];
        vm.cities                = [];
        vm.i                     = -1;
        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getByFilter           = getByFilter;
        vm.citySelected          = [];
        vm.citySelectedCSV       = '';
        vm.expoSelectedCSV       = '';
        vm.selectLetter          = [{id : 1 , name : 'Read Me'},{id : 2, name : 'You Have a seminar'}];
        vm.letterSelected        = [];
        vm.locationText          = "";
        vm.coffeeBreak           = "in the Foyer";
        vm.s3staticUrl           = 'http://static.edufindme.com.s3.amazonaws.com/';
        vm.download              = download;

        vm.options                  = {
            height: 300,
            focus: true,
            airMode: false,
            toolbar: [
                ['edit',['undo','redo']],
                ['headline', ['style']],
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['fontface', ['fontname']],
                ['textsize', ['fontsize']],
                ['fontclr', []],
                ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                ['height', ['height']],
                ['insert', ['link','hr']],
                ['view', ['fullscreen', 'codeview']],
                ['help', []]
            ]
        };

        vm.flagSeminar  = false;
        vm.flagReadme   = false;
        vm.expoLocation = [];

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getNewExpos().then(function(response){
                 vm.expo = response.data;
            }).catch(function(err) {
            });
        }

        function selectCitiesByExpo () {
            vm.citySelected          = [];
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.cities = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            if(typeof vm.citySelected !== 'undefined') {
                vm.query['location_id'] = vm.citySelected.expos_locations_id;
            }
            if(typeof vm.letterSelected !== 'undefined') {
                vm.query['letter'] = vm.letterSelected.id;
            }
            if(typeof vm.letterSelected !== 'undefined') {
                if(vm.letterSelected.id === 1)
                {
                    vm.flagReadme   = true;
                    vm.flagSeminar  = false;
                }
                else{
                    vm.flagReadme   = false;
                    vm.flagSeminar  = true;
                }
            }
            else{
                vm.flagReadme   = false;
                vm.flagSeminar  = false;
            }
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            /* Load variables to CSV */
            vm.citySelectedCSV  = vm.citySelected.expos_locations_id;
            vm.expoSelectedCSV  = vm.expoSelected.id;
            PhysicalFairService.getByFilterExpoLocation(vm.query).then(function(response){
                vm.expoLocation = response.data.letter;
                vm.text = response.data.letter.text_content;
                vm.file = response.data.file ? response.data.file : false;
                vm.flag = true;
            }).catch(function(err){
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function download() {
            vm.file = false;
            vm.query = {};
            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            if(typeof vm.citySelected !== 'undefined') {
                vm.query['location_id'] = vm.citySelected.expos_locations_id;
            }
            if(typeof vm.letterSelected !== 'undefined') {
                vm.query['letter'] = vm.letterSelected.id;
            }
            vm.query['coffeeBreak'] = vm.coffeeBreak;
            PhysicalFairService.downloadWelcomeLetter(vm.query).success(function(response) {
                vm.file = response.url;
                // var anchor = document.createElement('a');
                // anchor.href = data.url;
                // anchor.target = '_blank';
                // anchor.download = 'welcome-letters.pdf';
                // document.body.appendChild(anchor);
                // anchor.click();
                // $timeout(function () {
                //     anchor.remove();
                // }, 50);
            }).error(function(data, status, headers, config) {
                vm.file = false;
            });
        }
        activate();
    }
})();